export { Timeline } from './timeline';
export { TimelineItem } from './timeline-item/timeline-item';

export type { TimelineProps, TimelineStylesNames } from './timeline';
export type { TimelineItemStylesNames, TimelineItemProps } from './timeline-item/timeline-item';
